import {
  default as Mui4SnackbarContent,
  SnackbarContentProps as Mui4SnackbarContentPropsType,
} from '@material-ui/core/SnackbarContent'
import { default as Mui5SnackbarContent } from '@mui/material/SnackbarContent'
import { forwardRef, Ref } from 'react'
import { useComponentVersion } from '../hooks'

export enum OsSnackbarContentVersion {
  V1 = 1, // MUI4 + OS Theme
  V2 = 2, // MUI5 + Stratis
}

export type SnackbarContentProps = Mui4SnackbarContentPropsType

export const SnackbarContent = forwardRef<HTMLDivElement, SnackbarContentProps>((props, ref) => {
  const version = useComponentVersion('snackbar_content')

  switch (version) {
    case OsSnackbarContentVersion.V2: {
      return <Mui5SnackbarContent {...props} ref={ref as Ref<HTMLDivElement>} />
    }

    default:
      return <Mui4SnackbarContent {...props} />
  }
})
